import moment = require('moment');

export function getExceptionDays(string){
    try{
        let exceptionSplit = string.split("Exceptions()");
        var results = exceptionSplit[1].split(")()").map(f=>parseInt(f.split("d|")[1])).filter(d=>d);
        return results;
    } catch(err){
        console.log("getting exception days error", err);
        return [];
    }
}



export function getWorkDays(string){
    let exceptionSplit = string.split("(0||Exceptions()");
    var results = exceptionSplit[0].split("DaysOfWeek()")[1];
    let possibleDays =[1,2,3,4,5,6,7];
    possibleDays=possibleDays.filter(day=>!results.includes(day+"()()")).map(day=>day-1);
    return possibleDays;
}


var fromOADate = (function() {
    var epoch = new Date(1899,11,30);
    var msPerDay = 8.64e7;

    return function(n) {
      // Deal with -ve values
      var dec = n - Math.floor(n);

      if (n < 0 && dec) {
        n = Math.floor(n) - dec;
      }

      return new Date(n*msPerDay + +epoch);
    }
  }());



export function addSubtractWorkDaysToDate(date, numberOfDays, workDays, exceptionDays){
    let start = daysSinceOAEpoch(date);
    let dateCounter=0;
    let datePusher=0;
    if(numberOfDays>0){
        while(numberOfDays>dateCounter){
            // add one, see if it is a workday
            datePusher++;
            let oAEpochCalcDate = start+datePusher;
            let isException = exceptionDays.includes(Math.round(oAEpochCalcDate));
            let isWorkDay = workDays.includes(fromOADate(oAEpochCalcDate).getDay());

            if(isWorkDay && !isException){
                dateCounter++;
            }
        }
        return Math.round(start+datePusher)
    } else if(numberOfDays<0){

        while(Math.abs(numberOfDays)>dateCounter){
            // add one, see if it is a workday
            datePusher++;
            let oAEpochCalcDate = start-datePusher;
            let isException = exceptionDays.includes(Math.round(oAEpochCalcDate));
            let isWorkDay = workDays.includes(fromOADate(oAEpochCalcDate).getDay());
            if(isWorkDay && !isException){
                dateCounter++;
            }

        }
        return Math.round(start-datePusher)
    }
    return start;
}

function isOffDay(oAday, workDays, exceptionDays){
    return exceptionDays.includes(Math.round(oAday)) || !workDays.includes(fromOADate(oAday).getDay())
}

export function daysBetween(date, date2, workDays, exceptionDays){
    let i = 0;
    let oaDate = Math.round(daysSinceOAEpoch(date));
    let oaDate2 = Math.round(daysSinceOAEpoch(date2));

    console.log("oaDate", oaDate)
    console.log("oaDate2", oaDate2)

    if(oaDate < oaDate2){
        while(isOffDay(oaDate, workDays, exceptionDays)){
            oaDate++;
            date = fromOADate(oaDate)
        }

        let a = Math.round(oaDate2-addSubtractWorkDaysToDate(date, i, workDays, exceptionDays));
        //js floating point issues make this the only option
        while((a>(-0.1) && a.toFixed()!="0") || isNaN(a)){

            a = Math.round(oaDate2-addSubtractWorkDaysToDate(date, i, workDays, exceptionDays))
            i++;
        }
        i--; // accounts for extra in loop
    } else if(oaDate > oaDate2) {

        while(isOffDay(oaDate, workDays, exceptionDays)){
            oaDate--;
            date = fromOADate(oaDate)
        }

        let a = Math.round(oaDate2-addSubtractWorkDaysToDate(date, i, workDays, exceptionDays));
        //js floating point issues make this the only option
        while((a<0.1 && a.toFixed()!="0") || isNaN(a)){
            a = Math.round(oaDate2-addSubtractWorkDaysToDate(date, i, workDays, exceptionDays));
            i--;
        }
        i++; // accounts for extra in loop
    }

    console.log("calculated difference", i)
    return i;

}

export function calculateProjectedFinish(date, duration, progress, type, dayHrs, workDays, exceptionDays):any{
    let daysToGo=calculateProjectedDuration(duration, progress, type, dayHrs);
    console.log("date, daysToGo, workDays, exceptionDays", date, daysToGo, workDays, exceptionDays)
    return fromOADate(addSubtractWorkDaysToDate(date, daysToGo, workDays, exceptionDays));
}

export function calculateProjectedDuration(duration, progress, type, dayHrs){
    let daysToGo;
    if(type==="PERCENT_COMPLETE"){
        daysToGo = Math.round((duration*(100-progress)/100)/dayHrs);
    } else {
        daysToGo = Math.round((duration-progress)/dayHrs);
    }
    return daysToGo;
}


export function daysSinceOAEpoch(newDate){
    var epoch = new Date("1899-12-30T00:00:00"); // 1899-12-30T00:00:00
    console.log("daysSinceOAEpoch(newDate)", newDate)
    newDate.setHours(0,0,0,0);
    return Math.abs((epoch as any - newDate) / 8.64e7);
}


export function getFinishDelta(activity, workDays, exceptionDays){
    return daysBetween(activity.actualFinish,
        activity.earlyFinish,
        workDays,
        exceptionDays)
}

export function getStartDelta(activity, workDays, exceptionDays){
    return daysBetween(activity.actualStart,
        activity.earlyStart,
        workDays,
        exceptionDays)
}

export function getDayVsScheduledStart(day, activity, workDays, exceptionDays){
    return daysBetween(day,
        moment(activity.taskRow.act_start_date || activity.earlyStart).toDate(),
        workDays,
        exceptionDays)
}

export function getDayVsScheduledEnd(day, activity, workDays, exceptionDays){
    return daysBetween(day,
        activity.actualStart || activity.earlyStart,
        workDays,
        exceptionDays)
}

export function getOriginalProjectedDuration(activity, workDays, exceptionDays){
    return activity.originalDuration;
    // return daysBetween(activity.earlyStart, activity.earlyFinish,
    // workDays,
    // exceptionDays);
}


export function getDurationDelta(activity, workDays, exceptionDays){
    let remainingProjectedDuration = daysBetween(activity.actualStart, activity.actualFinish,
        workDays,
        exceptionDays);
    let originalProjectDuration = getOriginalProjectedDuration(activity, workDays, exceptionDays);

    return originalProjectDuration-remainingProjectedDuration-1;
}




export function getPercentCompleteInProgressProjectedFinish(day, activity, workDays, exceptionDays):any{
    let originalProjectedDuration = getOriginalProjectedDuration(activity, workDays, exceptionDays);

    let remainingDurationPercent = 1 - (activity.progressAmount/100);

    let estimatedRemainingDuration = Math.ceil(originalProjectedDuration*remainingDurationPercent).toFixed()


    return fromOADate(addSubtractWorkDaysToDate(day, estimatedRemainingDuration, workDays, exceptionDays));
}



export function getPercentCompleteInProgressFinishDelta(day, activity, workDays, exceptionDays){
    let projectedFinish = getPercentCompleteInProgressProjectedFinish(day, activity, workDays, exceptionDays);

    return daysBetween(projectedFinish, activity.earlyFinish,
        workDays,
        exceptionDays);
}

export function getPercentCompleteInProgressProjectedDuration(day, activity, workDays, exceptionDays){
    let projectedFinish = getPercentCompleteInProgressProjectedFinish(day, activity, workDays, exceptionDays);

    let ret= daysBetween(activity.actualStart, projectedFinish,
        workDays,
        exceptionDays);
    ret++;
    return ret;
}

export function getPercentCompleteInProgressDurationDelta(day, activity, workDays, exceptionDays){


    let remainingProjectedDuration = getPercentCompleteInProgressProjectedDuration(day, activity, workDays, exceptionDays)
    let originalProjectedDuration = getOriginalProjectedDuration(activity, workDays, exceptionDays);
    return originalProjectedDuration-remainingProjectedDuration;
}



export function getRemainingDurationInProgressProjectedFinish(day, activity, workDays, exceptionDays):any{
    let estimatedRemainingDuration = activity.progressAmount;

    return fromOADate(addSubtractWorkDaysToDate(day, estimatedRemainingDuration, workDays, exceptionDays));
}



export function getRemainingDurationInProgressFinishDelta(day, activity, workDays, exceptionDays){
    let projectedFinish = getRemainingDurationInProgressProjectedFinish(day, activity, workDays, exceptionDays);

    return daysBetween(projectedFinish, activity.earlyFinish,
        workDays,
        exceptionDays);
}

export function getRemainingDurationInProgressProjectedDuration(day, activity, workDays, exceptionDays){

    console.log("day, activity, workDays, exceptionDays", day, workDays, exceptionDays);
    let projectedFinish = getRemainingDurationInProgressProjectedFinish(day, activity, workDays, exceptionDays);

    console.log("projectedFinish,",projectedFinish)
    let ret= daysBetween(activity.actualStart, projectedFinish,
        workDays,
        exceptionDays);
    ret++;
    console.log("expected projectedFinish value", ret)
    return ret;
}

export function getRemainingDurationInProgressDurationDelta(day, activity, workDays, exceptionDays){


    let remainingProjectedDuration = getRemainingDurationInProgressProjectedDuration(day, activity, workDays, exceptionDays)
    let originalProjectedDuration = getOriginalProjectedDuration(activity, workDays, exceptionDays);

    return originalProjectedDuration-remainingProjectedDuration;
}






// WEBPACK FOOTER //
// ./src/services/p6calendar.ts